module.exports = __webpack_public_path__ + "static/img/TaideArtPisteValkoinen.c6fd6fc.svg";